import { useState } from 'react';
import { Save, X, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { reportError } from './reportConfig';

export const ReportEntryForm = ({ tipo, entry, today, onSave, onCancel }) => {
  const [form, setForm] = useState({ titolo: entry?.titolo || '', area: entry?.area || '',
    testo: entry?.testo || '', data: entry?.data || today, cosa_manca: entry?.cosa_manca || '' });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const prefix = `report-form-${entry?.id || tipo.toLowerCase()}`;
  const dated = ['FEATURE', 'CONTROLLO'].includes(tipo);
  const withArea = ['FEATURE', 'TODO', 'TASK_APERTO'].includes(tipo);
  const change = (field) => (event) => setForm({ ...form, [field]: event.target.value });

  const submit = async (event) => {
    event.preventDefault();
    setSaving(true);
    setError('');
    const values = { ...form, data: dated ? form.data : null };
    try {
      await onSave(entry ? values : { ...values, tipo });
    } catch (err) {
      setError(reportError(err));
      setSaving(false);
    }
  };

  return (
    <form onSubmit={submit} data-testid={prefix} className="report-editor rounded-lg border border-gray-300 bg-white p-4 sm:p-5">
      <fieldset disabled={saving} className="min-w-0 space-y-4">
        <legend className="mb-3 text-sm font-semibold" data-testid={`${prefix}-heading`}>{entry ? 'Modifica voce' : 'Nuova voce'}</legend>
        {tipo !== 'NOTA' && <div>
          <Label htmlFor={`${prefix}-title`}>Titolo</Label>
          <Input id={`${prefix}-title`} data-testid={`${prefix}-title`} value={form.titolo} onChange={change('titolo')} maxLength={180} required autoFocus className="mt-1" />
        </div>}
        {(withArea || dated) && <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          {withArea && <div>
            <Label htmlFor={`${prefix}-area`}>Area funzionale</Label>
            <Input id={`${prefix}-area`} data-testid={`${prefix}-area`} value={form.area} onChange={change('area')} maxLength={80} required className="mt-1" />
          </div>}
          {dated && <div className="min-w-0">
            <Label htmlFor={`${prefix}-date`}>Data di implementazione</Label>
            <Input id={`${prefix}-date`} data-testid={`${prefix}-date`} type="date" value={form.data} max={today} onChange={change('data')} required className="mt-1 w-full min-w-0" />
          </div>}
        </div>}
        <div>
          <Label htmlFor={`${prefix}-text`}>{tipo === 'NOTA' ? 'Nota / idea' : tipo === 'CONTROLLO' ? 'Cosa devo controllare' : 'Descrizione'}</Label>
          <Textarea id={`${prefix}-text`} data-testid={`${prefix}-text`} value={form.testo} onChange={change('testo')} maxLength={10000} required rows={3} autoFocus={tipo === 'NOTA'} className="mt-1 resize-y" />
        </div>
        {tipo === 'TASK_APERTO' && <div>
          <Label htmlFor={`${prefix}-missing`}>Cosa manca per proseguire</Label>
          <Textarea id={`${prefix}-missing`} data-testid={`${prefix}-missing`} value={form.cosa_manca} onChange={change('cosa_manca')} maxLength={4000} required rows={2} className="mt-1" />
        </div>}
        {error && <p role="alert" data-testid={`${prefix}-error`} className="text-sm text-red-700">{error}</p>}
        <div className="flex flex-wrap gap-2">
          <Button type="submit" data-testid={`${prefix}-save`} className="gap-2 bg-blue-600 hover:bg-blue-700">
            {saving ? <Loader2 className="h-4 w-4 animate-spin" /> : <Save className="h-4 w-4" />} {saving ? 'Salvataggio…' : 'Salva'}
          </Button>
          <Button type="button" variant="outline" data-testid={`${prefix}-cancel`} onClick={onCancel} className="gap-2"><X className="h-4 w-4" />Annulla</Button>
        </div>
      </fieldset>
    </form>
  );
};